// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"832578d89f78aca9","4051":"b4207c15de961ae3","4603":"a114b9e5bd20b585","6979":"44804ad52a64ab5a"}[chunkId] + ".css";
};